import { render, staticRenderFns } from "./register_verificate12306.vue?vue&type=template&id=e32ff2ae"
import script from "./register_verificate12306.vue?vue&type=script&lang=js"
export * from "./register_verificate12306.vue?vue&type=script&lang=js"
import style0 from "./register_verificate12306.vue?vue&type=style&index=0&id=e32ff2ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports